module.exports = __webpack_public_path__ + "static/favicon-dd32f34f56a0a40bc017fa77d9e4b8ca.ico";